import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis, Cell } from "recharts";
import { api } from "@/lib/api";
import { KpiCard, PageHeader, Panel } from "@/components/common";
import { DSTATUS, SimBadge } from "@/components/dds";

const toBars = (o) => Object.entries(o).map(([k, v]) => ({ name: DSTATUS[k]?.[0] || k, value: v, color: DSTATUS[k]?.[2] || "#D52B3B" }));

function Bars({ title, data, testid }) {
  return <Panel title={title} testid={testid}><div className="h-52"><ResponsiveContainer initialDimension={{ width: 400, height: 200 }}><BarChart data={data}><CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" /><XAxis dataKey="name" tick={{ fontSize: 11 }} /><YAxis allowDecimals={false} tick={{ fontSize: 11 }} /><Tooltip /><Bar dataKey="value" radius={[4, 4, 0, 0]}>{data.map((d) => <Cell key={d.name} fill={d.color} />)}</Bar></BarChart></ResponsiveContainer></div></Panel>;
}

export default function DdsDashboard() {
  const [d, setD] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/dds/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return null;
  return (
    <div data-testid="dds-dashboard-page">
      <PageHeader title="DDS dashboard" subtitle="Statements by status, plant, entity and activity, and the submission timeline."><SimBadge show={d.mode === "simulation"} /></PageHeader>
      <div className="mb-5 grid gap-4 sm:grid-cols-5">
        <KpiCard label="Statements" value={d.total} testid="dds-kpi-total" />
        <KpiCard label="Available" value={d.by_status.available || 0} tone="emerald" testid="dds-kpi-available" />
        <KpiCard label="Blocked / needs attention" value={(d.by_status.blocked || 0) + (d.by_status.invalid || 0)} tone="rose" testid="dds-kpi-blocked" />
        <KpiCard label="Ready to submit" value={d.by_status.ready || 0} tone="brand" testid="dds-kpi-ready" />
        <KpiCard label="In-scope PO lines with no plant" value={d.no_plant} sub="Set vendor default plants →" tone="amber" testid="dds-kpi-no-plant" onClick={() => nav("/vendor-plants?tab=no-plant")} />
      </div>
      <div className="grid gap-5 lg:grid-cols-2 xl:grid-cols-4">
        <Bars title="By status" data={toBars(d.by_status)} testid="dds-chart-status" />
        <Bars title="By plant" data={toBars(d.by_plant)} testid="dds-chart-plant" />
        <Bars title="By entity" data={toBars(d.by_entity)} testid="dds-chart-entity" />
        <Bars title="By activity" data={toBars(d.by_activity)} testid="dds-chart-activity" />
      </div>
      <Panel title="Timeline" className="mt-5" testid="dds-timeline">
        <div className="h-60"><ResponsiveContainer initialDimension={{ width: 800, height: 220 }}><BarChart data={d.timeline}><CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" /><XAxis dataKey="day" tick={{ fontSize: 11 }} /><YAxis allowDecimals={false} /><Tooltip /><Legend />
          <Bar dataKey="created" fill="#94A3B8" /><Bar dataKey="submitted" fill="#4F46E5" /><Bar dataKey="available" fill="#059669" /></BarChart></ResponsiveContainer></div>
      </Panel>
    </div>
  );
}
